<div class="tab-pane" role="tabpanel" id="tipocip">
    <fieldset id="agregar_tipocip" class="">
        <div class="step_section">
            <form [formGroup]="form">
                <div class="row" id="row">

                    <div class="col-md-12" id="content">
                        <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="tp_dir_message"></span>
                        </div>
                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <div class="col-sm-2">
                                    <label for="certcip">Certificado de Informaciones Previas(<span style="color:red; font-size: 17px">*</span>)</label>
                                </div>
                                <div class="col-sm-3" align="left">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Certificado" id="certcip" name="certcip" formControlName="certcip" (change)="add_cip()" [errorStateMatcher]="matcher">
                                        <mat-error *ngIf="form.controls?.certcip.hasError('required')">
                                            Este campo es <strong>obligatorio</strong>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-sm-2" align="left">
                                    <label for="fcip" style="margin-top: 12px;">Fecha CIP(<span style="color:red; font-size: 17px">*</span>)</label>
                                </div>
                                <div class="input-group col-sm-2" align="left" style="padding-left: 11px;">
                                    <mat-form-field style="width: 145px">
                                        <input matInput [matDatepicker]="dp3" id="fecha_cip" name="fecha_cip" formControlName="fecha_cip" [max]="maxDate" (dateinput)="add_cip($event, 'input')" (dateChange)="add_cip( $event, 'change')">
                                        <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                                        <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </form>
        </div>
    </fieldset>
</div>
<div class="separator"></div>